import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Alert } from "react-bootstrap";
import moment from "moment";

class LicenseExpirationWarningContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { customerId: props.customerId };
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const { stores } = this.props;
    await stores.data.ApplicationsStore.fetch();
    await stores.data.LicensesStore.fetchByCustomerId(this.state.customerId);
  }

  filterLicensesAboutToExpire(license) {
    let aboutToExpire = false;
    if (license.EndDate) {
      const expiryDate = new Date(license.EndDate);
      if (expiryDate) {
        const dayWeekBeforeExpiryDate = expiryDate.getDate() - 7;
        const weekBeforeExpiry = new Date(expiryDate.setDate(dayWeekBeforeExpiryDate));
        if (weekBeforeExpiry) {
          aboutToExpire = weekBeforeExpiry < new Date();
        }
      }
    }
    return aboutToExpire;
  }

  render() {
    const { stores } = this.props;

    // Filter the licenses with an expiry date for next week
    const licensesAboutToExpire = stores.data.LicensesStore.filter(this.filterLicensesAboutToExpire);

    const aboutToExpire = licensesAboutToExpire.map(license => {
      const application = stores.data.ApplicationsStore.findById(license.ApplicationId);
      license.ApplicationName = application.Name;
      return license;
    });

    let warning = null;
    if (licensesAboutToExpire.length > 0) {
      warning = <LicenseExpirationWarning licenses={aboutToExpire} />;
    }

    return warning;
  }
}

const LicenseExpirationWarning = props => {
  return (
    <Alert bsStyle="warning">
      {props.licenses.map(license => {
        return (
          <p key={license.Id}>
            License for {license.ApplicationName} is about to expire on {moment(license.EndDate).format("L")}
          </p>
        );
      })}
    </Alert>
  );
};

export default inject("stores")(observer(LicenseExpirationWarningContainer));



// WEBPACK FOOTER //
// ./src/Components/LicenseExpirationWarning/LicenseExpirationWarning.js